import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import i18n from 'i18n'
import SocialAccountsContent from './SocialAccounts'
import Tags from './Tags'
import PricingContent from './Pricing'
import styled from 'styled-components'
import { JazeelContext } from '../../../utils/JazeelContext'
import Section from 'components/Section'
import Image from 'react-bootstrap/Image'
import degree from 'assets/images/dashboard/Bitmap.png'
import CampaignComponent from '../../../influencerComponents/CampaignComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle'
import Container from 'react-bootstrap/Container'
import ProfileSection from 'Brands/containers/BrandDashboard/ProfileSection'
import Card from 'react-bootstrap/Card'
import { influencerDashboard } from 'CampaignSystem/services/requests'
import LoaderComponent from 'components/Loader'
import Swiper from 'react-id-swiper'
import 'swiper/css/swiper.css'
import { RTL } from 'locales/currentLang'
import langUrl from '../../../../CampaignSystem/utils/langUrl'

const InfluencerContainer = styled(Container)`
  overflow-x: hidden;
  text-align: ${props => props.theme.reverseDir};
  .title {
    color: #212529;
    font-size: 1.125em;
    font-weight: bold;
    line-height: 2.25em;
    margin-bottom: 0;
    @media screen and (max-width: 375px) {
      line-height: 1.8em;
    }
  }
  .description {
    opacity: 0.5;
    color: #212529;
    font-size: 0.875em;
  }
  .arrow {
    text-align: ${props => props.theme.dir};
    align-self: center;
    color: #777777;
  }
`
const PointContainer = styled(Card)`
  width: 100%;
  color: #212529;
  font-size: 0.875em;
  letter-spacing: 0;
  line-height: 1.125em;
  text-align: center;
  padding: 2.125em 2.125em 1.5em;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 6px 26px 0 rgba(0, 0, 0, 0.08);
  border: none;
  margin-bottom: 1em;
`
const Points = styled.h3`
  font-size: ${props => (props.size ? props.size : '4.063em')};
  font-weight: bold;
  line-height: ${props => (props.height ? props.height : '1em')};
`
const Nickname = styled.p`
  color: #777777;
  font-size: 0.938em;
  line-height: 1.188em;
  padding-top: 1.313em;
`
const DashboardTitle = styled.h3`
  color: #212529;
  font-size: 1.125em;
  font-weight: bold;
  line-height: 1.375em;
  padding: 1.438em 1.125em 2.313em;
`
const MemberWrapper = styled(Row)`
  margin-top: -1em;
`
const MemberText = styled.h3`
  color: #212529;
  font-size: 1.125em;
  font-weight: bold;
  line-height: 1.375em;
  text-align: ${props => props.theme.reverseDir};
`
const NoRank = styled.h3`
  color: #212529;
  font-size: 0.875em;
  font-weight: bold;
  line-height: 1.125em;
  text-align: center;
`
const Count = styled.p`
  color: #54ce9d;
  font-size: 0.875em;
  line-height: 1.125em;
`
const Accounts = styled.p`
  color: #777777;
  font-size: 0.75em;
  line-height: 0.938em;
`
const ActiveCampaign = styled.p`
  height: 0.625em;
  width: 0.625em;
  margin-top: -3.1em;
  font-size: 0.938em;
  line-height: 1.188em;
`
const CampaignContainer = styled(Container)`
  @media screen and (min-width: 576px) and (max-width: 768px) {
    margin: 0;
  }
`

export default function Influencer() {
  const { isMobile, isSmallMobile } = useContext(JazeelContext)
  const [details, setDetails] = useState(null)
  const params = {
    slidesPerView: 2,
    spaceBetween: 5,
    rebuildOnUpdate: true,
  }
  useEffect(() => {
    let isSubscribed = true
    influencerDashboard().then(res => {
      if (isSubscribed) {
        setDetails(res.data.data)
      }
    })
    return () => (isSubscribed = false)
  }, [])
  return (
    <Fragment>
      <LoaderComponent visible={!details} />
      {details && (
        <InfluencerContainer className="mt-3 animated fadeIn">
          <div className="container-fluid">
            <Row>
              {/*<Col xs={12} className="mb-3 p-0">*/}
              {/*  /!* <Breadcrumb pageTitle={'Influencer'} /> *!/*/}
              {/*  <InfluencerContent className="mt-5">*/}
              {/*    <div className="card">*/}
              {/*      <div className="card-body p-5">*/}
              {/*        <NoRank>*/}
              {/*          Your do not have any ranking, connect your social media*/}
              {/*          account to Jazeel to attract hot brands and marketers*/}
              {/*        </NoRank>*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*  </InfluencerContent>*/}
              {/*</Col>*/}
              <DashboardTitle>
                {i18n.t('influencer.dashboard.title')}
              </DashboardTitle>
              <PointContainer>
                <Row className="m-0 text-center">
                  <Col sm={12}>
                    <p>
                      {i18n.t('general.you')} {i18n.t('general.have')}
                    </p>
                    <Points>0</Points>
                    <Points size="1.125em" height="1.375em">
                      {i18n.t('influencer.dashboard.points')}
                    </Points>
                    {RTL() ? (
                      <Nickname>{details.nickname}@</Nickname>
                    ) : (
                      <Nickname>@{details.nickname}</Nickname>
                    )}
                  </Col>
                </Row>
              </PointContainer>
              {/*<Section*/}
              {/*  left="0"*/}
              {/*  width="94vw"*/}
              {/*  title={i18n.t('influencer.dashboard.rank')}*/}
              {/*  titleSize="0.875em"*/}
              {/*  titleWeight="300"*/}
              {/*  lineHeight="2.125em"*/}
              {/*  top="1.438em"*/}
              {/*>*/}
              {/*  <MemberWrapper>*/}
              {/*    <Col xs={4}>*/}
              {/*      <Image src={degree} fluid />*/}
              {/*    </Col>*/}
              {/*    <Col xs={8} className="p-0">*/}
              {/*      <MemberText>{i18n.t('general.soon')}</MemberText>*/}
              {/*      /!* <Count>More than 5k followers</Count>*/}
              {/*      <Accounts>*/}
              {/*        {details?.connected_accounts}{' '}*/}
              {/*        {i18n.t('influencer.dashboard.connected')}*/}
              {/*      </Accounts> *!/*/}
              {/*    </Col>*/}
              {/*  </MemberWrapper>*/}
              {/*</Section>*/}

              <CampaignContainer className="p-0">
                {details?.compaigns_requests?.length > 0 && (
                  <Section
                    width={isSmallMobile ? '100vw' : '100%'}
                    left="0"
                    title={`${details?.compaigns_requests_count} ${i18n.t(
                      'influencer.dashboard.requests',
                    )}`}
                    view={i18n.t('general.all')}
                    path={`/${langUrl}/influencer/campaigns`}
                    titleSize="0.875em"
                    titleWeight="300"
                    lineHeight="2.125em"
                    radius="20px"
                    viewWidth="5em"
                  >
                    <Swiper {...params}>
                      {details?.compaigns_requests.map(campaign => (
                        <CampaignComponent
                          src={campaign.brand_image}
                          width="6em"
                          title={campaign.campaign_name}
                          deadline={campaign.campaign_start_date}
                          path={`/${langUrl}/influencer/campaign/${campaign.id}`}
                          key={campaign.id}
                        />
                      ))}
                    </Swiper>
                  </Section>
                )}
                {details?.active_compaigns?.length > 0 && (
                  <Section
                    title={i18n.t('influencer.dashboard.active')}
                    titlePadding={RTL() ? '0 1.3em 0 0' : '0 0 0 1.3em'}
                    left="0"
                    radius="20px"
                  >
                    <ActiveCampaign>
                      <FontAwesomeIcon
                        icon={faCircle}
                        color="#54CE9D"
                        size="xs"
                        className={RTL() ? 'ml-2' : 'mr-2'}
                      />
                    </ActiveCampaign>
                    <Swiper {...params}>
                      {details?.active_compaigns.map(campaign => (
                        <CampaignComponent
                          src={campaign.brand_image}
                          width="6em"
                          title={campaign.campaign_name}
                          deadline={campaign.campaign_start_date}
                          key={campaign.id}
                          path={`/${langUrl}/influencer/ongoing/campaign/${campaign.id}`}
                        />
                      ))}
                    </Swiper>
                  </Section>
                )}
                {details?.pending_compaigns?.length > 0 && (
                  <Section
                    title={i18n.t('influencer.dashboard.pending')}
                    titlePadding={RTL() ? '0 1.3em 0 0' : '0 0 0 1.3em'}
                    left="0"
                    radius="20px"
                  >
                    <ActiveCampaign>
                      <FontAwesomeIcon
                        icon={faCircle}
                        color="#DEA618"
                        size="xs"
                        className="mr-2"
                      />
                    </ActiveCampaign>
                    <Swiper {...params}>
                      {details?.pending_compaigns.map(campaign => (
                        <CampaignComponent
                          src={campaign.brand_image}
                          width="6em"
                          title={campaign.campaign_name}
                          deadline={campaign.campaign_start_date}
                          key={campaign.id}
                          path={`/${langUrl}/influencer/ongoing/campaign/${campaign.id}`}
                        />
                      ))}
                    </Swiper>
                  </Section>
                )}
              </CampaignContainer>

              {/*<InformationSection color="transparent" />*/}
              <Col xs={12} className="mb-3 px-0">
                <SocialAccountsContent
                  accountsLength={details?.connected_accounts}
                />
              </Col>
              <Col
                xs={12}
                className={`mb-3 px-0 ${isMobile ? 'px-0' : 'pr-2'}`}
              >
                <PricingContent />
              </Col>
              <Col
                xs={12}
                md={12}
                className={`mb-4 px-0 ${isMobile ? 'px-0' : 'pr-2'}`}
              >
                <Tags />
              </Col>

              <Col
                xs={12}
                md={12}
                className={`mb-4 px-0 ${isMobile ? 'px-0' : 'pr-2'}`}
              >
                <ProfileSection
                  name=""
                  website=""
                  percent={details.profile_complete}
                  to={`/${langUrl}/influencer/profile`}
                />
              </Col>
            </Row>
          </div>
        </InfluencerContainer>
      )}
    </Fragment>
  )
}
